import * as methods from 'api/core/actions';
import * as z from 'zod';

const changeValue = z.union([z.string(), z.number(), z.boolean(), z.array(z.number()), z.null()]);
const responseSchema = z.object({
  audits: z.array(
    z.object({
      id: z.number(),
      action: z.enum(['create', 'update']),
      target: z.enum(['periods', 'session']),
      period_ids: z.array(z.number()),
      changes: z.record(z.string(), z.tuple([changeValue, changeValue])),
      comment: z.string().nullable(),
      user: z
        .object({
          id: z.number().nullable(),
          name: z.string(),
          avatar: z.object({ medium_retina: z.string().nullish() }).nullish(),
        })
        .nullable(),
      created_at: z.string(),
    })
  ),
  projects: z.array(z.object({ id: z.number(), name: z.string(), color: z.string().nullable() })),
  truncated: z.boolean(),
  next_before: z.number().nullable(),
});

export type AgentSessionAudits = z.infer<typeof responseSchema>;
export type AgentSessionAudit = AgentSessionAudits['audits'][number];

export async function getAgentSessionAudits(
  sessionId: number,
  before?: number,
  get: (path: string) => Promise<unknown> = path => methods.Get(path)
): Promise<AgentSessionAudits> {
  return responseSchema.parse(
    await get(
      `agent_sessions/${sessionId}/audits${before === undefined ? '' : `?before=${before}`}`
    )
  );
}
